import Swiper from 'swiper'

export const initBusinessHeader = () => {
  const carousel = document.querySelector('.js-business-carousel')
  if (!carousel) { return false }

  new Swiper(carousel, {
    direction: 'horizontal',
    loop: false,
    watchOverflow: true,
    freeMode: true,
    spaceBetween: 20,
    slidesPerView: 'auto'
  })
}
